import { render, staticRenderFns } from "./VacationPage.vue?vue&type=template&id=530cdd66&"
import script from "./VacationPage.vue?vue&type=script&lang=js&"
export * from "./VacationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports